
import React from "react";
import { reactElement, reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { FloatingPortal, FloatingFocusManager, useFocus, useRole, useDismiss, useHover, useInteractions, autoUpdate, autoPlacement, useFloating } from "@floating-ui/react";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { singleton as singleton_1, ofArray, append as append_1 } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";

export function TooltipAnchor(props) {
    let elems_2;
    const patternInput = reactApi.useState(false);
    const isOpen = patternInput[0];
    const floatingProps = useFloating({
        middleware: [autoPlacement({
            allowedPlacements: ["bottom-start"],
        })],
        onOpenChange: patternInput[1],
        open: isOpen,
        whileElementsMounted: autoUpdate,
    });
    const getReferenceProps = useInteractions([useHover(floatingProps.context, {
        move: false,
    }), useDismiss(floatingProps.context), useRole(floatingProps.context, {
        role: "label",
    }), useFocus(floatingProps.context)]);
    return reactElement("div", createObj(ofArray([["ref", floatingProps.refs.setReference], (elems_2 = toList(delay(() => append(singleton(reactElement("div", createObj(append_1(ofArray([["ref", floatingProps.refs.setReference], ["children", reactApi.Children.toArray([props.Child])]]), getReferenceProps.getReferenceProps())))), delay(() => {
        let props_2, children_1, props_1, children;
        return isOpen ? singleton((props_2 = ofArray([["root", document.body], (children_1 = singleton_1((props_1 = ofArray([["context", floatingProps.context], ["modal", false], (children = singleton_1(reactElement("div", {
            className: join(" ", ["z-50", "outline-none"]),
            ref: floatingProps.refs.setFloating,
            style: floatingProps.floatingStyles,
            children: reactApi.Children.toArray([props.Tooltip]),
        })), ["children", reactApi_1.Children.toArray(children)])]), reactApi_1.createElement(FloatingFocusManager, createObj(props_1)))), ["children", reactApi_1.Children.toArray(children_1)])]), reactApi_1.createElement(FloatingPortal, createObj(props_2)))) : empty();
    })))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

